import { Button, ButtonVariant } from '@dreryk/react-components';

import { ConsentsAndAuthorizationsDocumentScannerModalOpener } from '~legacy.patient';

import { visitHistoryTranslationKeys } from '../../../translations';

type ScanDocumentCellProps = {
   readonly consentDocumentName: string;
   readonly consentDocumentId: number;
   readonly onConfirm: VoidFunction;
};

export const ScanDocumentCell = (props: ScanDocumentCellProps): JSX.Element => {
   return (
      <ConsentsAndAuthorizationsDocumentScannerModalOpener
         consentDocumentName={props.consentDocumentName}
         consentDocumentId={props.consentDocumentId}
         onConfirm={props.onConfirm}
      >
         {({ openModal }) => (
            <Button
               testId={'scanDocument'}
               label={visitHistoryTranslationKeys.patientConsentsTable.addDocumentScan}
               onClick={openModal}
               type={'button'}
               variant={ButtonVariant.SECONDARY}
            />
         )}
      </ConsentsAndAuthorizationsDocumentScannerModalOpener>
   );
};
